const fields = ['schema_version', 'environment', 'frontend_origin', 'api_origin', 'rest_base_url', 'wss_url', 'public_feature_flags']
let installed
function validateRuntimeConfig(value, actualOrigin) {
  if (!value || typeof value !== 'object' || Array.isArray(value) || Object.keys(value).filter(key => key !== 'public_map_browser_key').sort().join() !== fields.slice().sort().join()) throw new Error('RUNTIME_CONFIG_FIELDS')
  if (![1, 2].includes(value.schema_version) || !['staging', 'production', 'recovery-test'].includes(value.environment)) throw new Error('RUNTIME_CONFIG_SCHEMA')
  if (value.public_map_browser_key !== undefined && (typeof value.public_map_browser_key !== 'string' || value.public_map_browser_key.length > 128 || !/^[a-zA-Z0-9_-]*$/.test(value.public_map_browser_key))) throw new Error('RUNTIME_CONFIG_MAP_KEY')
  const urls = {}
  for (const key of ['frontend_origin', 'api_origin', 'rest_base_url', 'wss_url']) {
    if (typeof value[key] !== 'string') throw new Error('RUNTIME_CONFIG_URL')
    const u = new URL(value[key])
    if (u.username || u.password || u.search || u.hash || u.port || u.protocol !== (key === 'wss_url' ? 'wss:' : 'https:')) throw new Error('RUNTIME_CONFIG_URL')
    urls[key] = u
  }
  if (value.frontend_origin !== actualOrigin || urls.frontend_origin.origin !== value.frontend_origin || urls.api_origin.origin !== value.api_origin) throw new Error('RUNTIME_CONFIG_ORIGIN')
  const front = urls.frontend_origin.hostname.split('.')
  const label = value.environment === 'production' ? 'app' : 'dev'
  if (front.length < 3 || front[0] !== label || urls.api_origin.hostname !== (label === 'app' ? 'api.' : 'api-dev.') + front.slice(1).join('.')) throw new Error('RUNTIME_CONFIG_ENVIRONMENT')
  if (value.rest_base_url !== value.api_origin + '/rest' || value.wss_url !== 'wss://' + urls.api_origin.host + '/ws/notifications/') throw new Error('RUNTIME_CONFIG_PATH')
  const flags = value.public_feature_flags
  if (!flags || Array.isArray(flags) || typeof flags !== 'object') throw new Error('RUNTIME_CONFIG_FLAGS')
  if (value.schema_version === 1 && Object.keys(flags).length) throw new Error('RUNTIME_CONFIG_FLAGS')
  if (value.schema_version === 2 && (Object.keys(flags).sort().join() !== 'email_otp,sms_otp' || Object.values(flags).some(flag => typeof flag !== 'boolean'))) throw new Error('RUNTIME_CONFIG_FLAGS')
  return Object.freeze({ ...value, public_feature_flags: Object.freeze({ ...flags }) })
}
function installRuntimeConfig(value, origin) {
  installed = validateRuntimeConfig(value, origin)
  return installed
}
function getRuntimeConfig() {
  if (!installed) throw new Error('RUNTIME_CONFIG_NOT_LOADED')
  return installed
}
async function loadRuntimeConfig(fetcher = window.fetch.bind(window), origin = window.location.origin) {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), 10000)
  try {
    const response = await fetcher('/runtime-config.json', { cache: 'no-store', credentials: 'omit', redirect: 'error', signal: controller.signal })
    if (!response.ok || !response.headers.get('content-type')?.includes('application/json')) throw new Error('RUNTIME_CONFIG_RESPONSE')
    const text = await response.text()
    if (text.length > 8192) throw new Error('RUNTIME_CONFIG_SIZE')
    return installRuntimeConfig(JSON.parse(text), origin)
  } finally { clearTimeout(timer) }
}
module.exports = { validateRuntimeConfig, installRuntimeConfig, getRuntimeConfig, loadRuntimeConfig }
